export default __webpack_public_path__ + "static/video_gwbloop-3e315ff43db45a9fe6aa38d0568e5fdd.mp4";